;(function ($) {
    $(document).ready(function () {
        $(document).on('click','.sm-spoiler .panel-heading',function () {
            if( $(this).parent().hasClass('sm-open') ) {
                $(this).parent().removeClass('sm-open')
                $(this).parent().toggleClass('sm-close');
            } else {
                $(this).parent().removeClass('sm-close')
                $(this).parent().toggleClass('sm-open');
            }

        });
    });
}(jQuery));